"use strict";

import * as store from './store'
import { setViewportHeight, viewportAdjust } from './modules/utils'
import Loading from './modules/Loading'
import Drawer from './modules/Drawer'
import Home from './modules/Home'
import ScrollAnimations from './modules/ScrollAnimations'
import ScrollTo from './modules/ScrollTo'

import GlobaLHeader from './modules/GlobalHeader'
import PointerAnimation from './modules/PointerAnimation'
import AppCanvas from './AppCanvas'

import { gsap } from 'gsap/all'
const scrollTo = new ScrollTo()
let scrollAnimations;

let app = null;
let pointerAnimation = new PointerAnimation();
let lastUpdateTime = 0

const resize = {
  prevSize: { w: 0, h: 0 },
  checkTime: 0,
  interval: 500 * 0.001,
}

/**
 * @param {String} str
 * @return {String}
 */
const shredText = function(str){
    return [...str].map(char => `<span>${char}</span>`).join('');
}


/**
 * リサイズチェック
 *
 * @param {number} time - 現在の時間
 * @return {boolean} リサイズがあった場合はtrue、それ以外はfalse
 */
function checkResize(time) {
  // 設定したinterval秒が経過している場合のみ処理を実行
  if (time - resize.checkTime < resize.interval) return false
  resize.checkTime = time

  if (window.innerWidth !== resize.prevSize.w || window.innerHeight !== resize.prevSize.h) {
    resize.prevSize.w = window.innerWidth
    resize.prevSize.h = window.innerHeight
    return true
  }
  return false
}


const loading = new Loading('img')

const checkLoad = new Promise((resolve) => {
  loading.on('loaded', () => {
    resolve()
  })
})

function update() {
  requestAnimationFrame(update)

  const time = performance.now() * 0.001
  // リサイズすべきかチェック

  const deltaTime = time - lastUpdateTime
  lastUpdateTime = time

	if(app) {
		if (checkResize(time)) {
			app.resize()
		}
		// appを更新
		app.update({ time, deltaTime })
	}
}

const init = () => {
  // console.log('\u001b[32m' + 'init' + '\u001b[0m')
  setViewportHeight()
  viewportAdjust() // min375px
  update()

  if (document.body.classList.contains('home')) {
    const  shredTargets = document.querySelectorAll('.js-shredText');
    shredTargets.forEach(target => {
        //要素の内容を関数の実行結果で置き換える
        target.innerHTML = shredText(target.textContent);
    });

    gsap.fromTo('.js-shredText span', {
      autoAlpha: 0
    },
    {
      duration: 2,
      autoAlpha: 1,
      ease: 'power4.inOut',
      stagger: {
        each: .02,
        from: 'random',
      }
    })
    new Home()
  }

  Promise.all([checkLoad]).then((message) => {
    console.log('\u001b[32m' + 'loaded!' + '\u001b[0m')
    update()
    app.init()
    window.addEventListener('resize', () => {
       setViewportHeight()
    })
    document.documentElement.classList.add('is-loaded')
  })

  scrollAnimations = new ScrollAnimations();
  scrollAnimations.init()

}

window.addEventListener('DOMContentLoaded', () => {
  const drawer = new Drawer()
  const globalHeader = new GlobaLHeader()
  app = new AppCanvas()
  pointerAnimation.init()
  init()
  document.documentElement.classList.remove('now-loading');
})

